export const finance = {
  description: "إصدار الفواتير والدفعات والمصروفات ودفتر النقدية.",
  recordExpense: "تسجيل مصروف",
  recordPayment: "تسجيل دفعة",
  newInvoice: "فاتورة جديدة",
  invoices: "الفواتير",
  noInvoices: "لا توجد فواتير",
  noInvoicesDesc: "أنشئ فاتورة لفوترة أحد العملاء.",
  payments: "الدفعات",
  unapplied: "غير مخصصة",
  noPayments: "لا توجد دفعات",
  noPaymentsDesc: "سجّل دفعة من أحد العملاء.",
  selectInvoice: "اختر فاتورة لعرض الأسطر والرصيد والإجراءات.",
  moneyIn: "الأموال الواردة",
  moneyOut: "الأموال الصادرة",
  net: "الصافي",
  cashLedger: "دفتر النقدية",
  when: "التاريخ",
  direction: "الاتجاه",
  noCashMovements: "لا توجد حركات نقدية",
  noCashMovementsDesc: "تظهر هنا الدفعات والمصروفات.",
  expenseRecordedToast: "تم تسجيل المصروف",
  recordExpenseTitle: "تسجيل مصروف",
  invoiceCreatedToast: "تم إنشاء الفاتورة",
  createInvoice: "إنشاء الفاتورة",
  addLine: "إضافة سطر",
  invoiceIssuedToast: "تم إصدار الفاتورة",
  paymentRecordedToast: "تم تسجيل الدفعة",
  recordPaymentTitle: "تسجيل دفعة",
  dueOn: "يُستحق {date}",
  totalAmount: "الإجمالي {amount}",
  outstanding: "مستحق",
  issue: "إصدار",
  recordFullPayment: "تسجيل دفعة كاملة",
  invoiceOptional: "الفاتورة (اختياري)",
  unappliedPayment: "دفعة غير مخصصة",
};
